import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Header.module.css';

function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.logo}>DESTINY KIDS NURSERY AND PRIMARY SCHOOL</div>
      <nav className={styles.nav}>
        <a href="/">Home</a>
        <a href="/about">About</a>
        <a href="/programs">Programs</a>
        <a href="/vision-mission">Vision & Mission</a>
        <a href="/core-values">Core Values</a>
        <a href="/contact">Contact</a>
        <Link to="/gallery">Gallery</Link>

      </nav>
    </header>
  );
}

export default Header;
